import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as ROUTES from "../constants/routes";
import Markdown from "react-markdown";
import "../sass/news.scss";
import { fetchJson, formatShortDate } from "./newsApi";

function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadArticles() {
      try {
        setLoading(true);
        setError("");

        const data = await fetchJson(
          "/articles?populate=*&sort=publishedAt:desc"
        );

        if (!cancelled) {
          setArticles(data?.data || []);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Unable to load news.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadArticles();

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="news-container">
        <div className="news-status" role="status">
          <span className="news-status-spinner" aria-hidden="true" />
          <p>Loading Articles...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="news-container">
        <div className="news-status news-status--error" role="alert">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <main className="news">
      {articles.length === 0 ? (
        <div className="news-toolbar news-toolbar--empty">
          <p className="news-count">No news articles available.</p>
        </div>
      ) : (
        <>
          <div className="news-toolbar">
            <p className="news-count">
              {articles.length} {articles.length === 1 ? "article" : "articles"}
            </p>
          </div>

          {articles.map((article) => {
            const attributes = article.attributes || {};
            const categories = attributes.categories?.data || [];
            const body = attributes.body || "";
            const publishedLabel = formatShortDate(attributes.publishedAt);

            return (
              <article key={article.id} className="news-article">
                <h3 className="news-article-title">{attributes.title}</h3>

                {categories.length > 0 && (
                  <ul className="news-article-categories">
                    {categories.map((category) => (
                      <li key={category.id} className="news-article-category">
                        {category.attributes?.name}
                      </li>
                    ))}
                  </ul>
                )}

                {publishedLabel && (
                  <time
                    className="news-article-date"
                    dateTime={attributes.publishedAt}
                  >
                    {publishedLabel}
                  </time>
                )}

                <Markdown className="news-article-body">
                  {body.length > 500 ? `${body.substring(0, 500)}...` : body}
                </Markdown>

                <Link
                  to={`/${ROUTES.NEWS}/${ROUTES.NEWS_DETAIL}/${article.id}`}
                  className="news-read-more-button"
                >
                  Read More
                </Link>
              </article>
            );
          })}
        </>
      )}
    </main>
  );
}

export default News;
